import DataTable, {Order} from "datatables.net-bs5";

declare const eo_version : string;

export default class {
    static init = () => {
        mobs();
        npc();
    }
}

function mobs() {
    let table = document.querySelector('.datatable[data-table="eo_mobs"]') as HTMLElement;
    if(!table) {
        return;
    }

    let datatable = new DataTable('.datatable[data-table="eo_mobs"]',{
        pageLength: 20,
        lengthMenu: [10,20,50,100],
        processing: true,
        serverSide: true,
        ajax: {
            url: '?do=getMobs',
            data: function(data) {
                return data;
            }
        },
        columns: [
            { data: 'id', className: "align-middle" },
            { data: null, className: "align-middle", render: function(data) {
                    return `<img src="/assets/eo/${eo_version}/npc/${data.id}.png" class="eo-item-image-small" /> <a href="/eo/mobs/${data.id}">${data.name}</a>`;
                }},
            { data: null, className: "align-middle", render: function(data : any) {
                    if(data.boss == 1) {
                        return '<span class="badge bg-danger">Boss</span>';
                    } else if(data.child == 1) {
                        return '<span class="badge bg-primary">Child</span>';
                    } else if(data.behavior == 1 || data.behavior == 2) {
                        return '<span class="badge bg-secondary">Regular</span>';
                    } else {
                        return '-';
                    }
                } },
            { data: null, className: "align-middle", render: function(data : any) {
                    switch(data.behavior) {
                        case 1: return '<span class="badge bg-success">Passive</span>';
                        case 2: return '<span class="badge bg-danger">Aggressive</span>';
                        case 5: return '<span class="badge bg-black">Craft</span>';
                        case 6: return '<span class="badge bg-black">Shop</span>';
                        case 7: return '<span class="badge bg-black">Inn</span>';
                        case 9: return '<span class="badge bg-black">Bank</span>';
                        case 10: return '<span class="badge bg-black">Haircutter</span>';
                        case 11: return '<span class="badge bg-black">Guildmaster</span>';
                        case 12: return '<span class="badge bg-black">Priest</span>';
                        case 13: return '<span class="badge bg-black">Lawyer</span>';
                        case 14: return '<span class="badge bg-black">Book</span>';
                        case 15: return '<span class="badge bg-black">Quest</span>';
                        case 16: return '<span class="badge bg-primary">Collectable</span>';
                        case 17: return '<span class="badge bg-info">Milkable</span>';
                        case 18: return '<span class="badge bg-black">Charger</span>';
                        case 20: return '<span class="badge bg-black">Transport</span>';
                        default: return '-';
                    }
                } },
            { data: 'level', className: "align-middle" },
            { data: 'hp', className: "align-middle" },
            { data: 'damage', className: "align-middle" },
            { data: 'accuracy', className: "align-middle" },
            { data: 'evasion', className: "align-middle" },
            { data: 'armor', className: "align-middle" },
            { data: 'exp', className: "align-middle" },
            { data: 'respawn', className: "align-middle" },
        ],
        order: [[0,"asc"]] as Order[]
    });
}

function npc() {
    let container = document.querySelector('.container-eo-npc') as HTMLElement;
    if(!container) {
        return;
    }

    setInterval(() => {
        let images_visible = document.querySelectorAll('.eo-item-image:not(.d-none)');
        let images_hidden = document.querySelectorAll('.eo-item-image.d-none');
        images_visible.forEach((el) => el.classList.add('d-none'));
        images_hidden.forEach((el) => el.classList.remove('d-none'));
    }, 500);
}
